<template>
  <div v-if="selfData" class="print-head">
    <div class="head-top">{{ selfData.saler_company_name }}</div>
    <div class="head-center">
      <div class="head-left">
        <div>地址：{{ selfData.saler_company_address }}</div>
        <div>
          <span>业务员：{{ selfData.saler_name }}</span>
          <span class="m-l-10">业务员电话：{{ selfData.saler_phone }}</span>
        </div>
      </div>
      <div class="head-right">
        <div>送货单</div>
        <div>NO.{{ selfData.delivery_code }}</div>
      </div>
    </div>
    <div class="head-bottom">
      <span>客户编号：{{ selfData.customer_id }}</span>
      <span>联系人：{{ selfData.customer_linkman }}</span>
      <span>制单人：{{ selfAccountData.nick_name }}</span>
      <span>审核人：{{ selfData.checker_name }}</span>
      <span>送货日期：{{ selfData.delivery_date && selfData.delivery_date.slice(0, 10) }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selfData: null
    }
  },
  computed: {
    selfAccountData() {
      let result = this.$store.getters.getLoginAccount
      return result
    }
  },
  mounted() {
    this.selfData = this.data
  }
}
</script>

<style lang="less" scoped>
.print-head {
  font-weight: bold;
  .head-top {
    text-align: center;
    font-size: 24px;
  }
  .head-center {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    line-height: 24px;
    font-size: 14px;
    color: @colorRed;
    .head-left {
    }
    .head-right {
      text-align: center;
    }
  }
  .head-bottom {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }
}
</style>
